import { render, staticRenderFns } from "./CheckoutWizardStepPayment.vue?vue&type=template&id=32a2ad7d&scoped=true"
import script from "./CheckoutWizardStepPayment.vue?vue&type=script&lang=ts"
export * from "./CheckoutWizardStepPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2ad7d",
  null
  
)

export default component.exports